import { round } from '../../platform/geom/Math';

export const precisionFilter = (dp: number) =>
    (value: number) => round(value, dp);

export const integerFilter = precisionFilter(0);
